module.exports = __webpack_public_path__ + "img/dowm-code.07f9110b.png";